export default {
  name: 'paddingBox',
  data() {
    return {};
  }
};